export default function Products() {
  const categories = [
    {
      icon: 'ri-computer-line',
      label: 'PC & WORKSTATION',
      title: 'Potenza senza compromessi',
      description: 'Dalle workstation professionali per il rendering 3D ai laptop ultraleggeri per il business in movimento: selezioniamo per te solo hardware di alta gamma con garanzia verificata. Configurazioni custom su misura per ogni esigenza lavorativa.',
      features: ['Desktop custom assemblati', 'Laptop business & gaming', 'Workstation professionali', 'Upgrade e potenziamenti'],
      image: 'https://public.readdy.ai/ai/img_res/3b79615ae15c4021684579a5d46799ad.jpg',
    },
    {
      icon: 'ri-smartphone-line',
      label: 'SMARTPHONE & TABLET',
      title: 'Connettiti al massimo',
      description: 'I migliori smartphone e tablet del mercato, selezionati per chi non accetta compromessi. Dispositivi top di gamma per professionisti e aziende, con configurazioni enterprise e supporto dedicato. Sempre connesso, sempre produttivo.',
      features: ['iPhone & Android flagship', 'Tablet professionali', 'Attivazione aziendale', 'Piani MDM & gestione flotta'],
      image: 'https://readdy.ai/api/search-image?query=Premium%20smartphones%20and%20tablets%20elegantly%20arranged%20on%20a%20clean%20white%20surface%2C%20high-end%20mobile%20devices%20with%20sleek%20designs%2C%20professional%20product%20display%20of%20latest%20flagship%20phones%2C%20minimalist%20photography%20style%2C%20soft%20shadows%2C%20sophisticated%20tech%20product%20presentation%2C%20modern%20and%20luxurious%20aesthetic&width=700&height=500&seq=products-mobile-lios-002&orientation=landscape',
    },
    {
      icon: 'ri-headphone-line',
      label: 'ACCESSORI & PERIFERICHE',
      title: 'Ogni dettaglio conta',
      description: 'Tastiere meccaniche, monitor 4K, cuffie noise-cancelling, dock station e tutto ciò che trasforma la tua postazione in un ambiente di lavoro d\'eccellenza. Perché ogni dettaglio fa la differenza nella tua produttività quotidiana.',
      features: ['Monitor 4K & ultrawide', 'Tastiere & mouse ergonomici', 'Cuffie & audio professionale', 'Dock, hub & networking'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20tech%20accessories%20collection%20including%20mechanical%20keyboard%2C%20premium%20headphones%2C%20sleek%20mouse%20and%20monitor%20on%20a%20clean%20minimalist%20desk%20setup%2C%20high-end%20office%20peripherals%20elegantly%20displayed%2C%20sophisticated%20product%20photography%20with%20neutral%20tones%2C%20modern%20workspace%20accessories%20beautifully%20arranged&width=700&height=500&seq=products-acc-lios-003&orientation=landscape',
    },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="prodotti" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">

        {/* Section Header */}
        <div className="mb-24">
          <p className="text-sm text-gray-500 uppercase tracking-wider mb-4 font-light">
            HARDWARE & DISPOSITIVI
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight">
              TECNOLOGIA<br />
              <span className="text-[#1A4D4D]">AL TUO SERVIZIO</span>
            </h2>
            <p className="text-gray-600 font-light leading-relaxed max-w-xl text-lg">
              Non solo software. Lios è il tuo partner completo per la tecnologia: 
              selezioniamo, configuriamo e consegniamo i migliori dispositivi 
              hardware direttamente in azienda o a casa tua.
            </p>
          </div>
        </div>

        {/* Product Cards */}
        <div className="space-y-16">
          {categories.map((cat, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-0 rounded-3xl overflow-hidden bg-[#F8F6F3] hover:scale-[1.01] transition-transform duration-300`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2 h-72 lg:h-auto min-h-[380px]">
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Text Content */}
              <div className="w-full lg:w-1/2 p-12 lg:p-16 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${cat.icon} text-3xl text-[#1A4D4D]`}></i>
                  </div>
                  <span className="text-xs font-semibold text-[#FF6B35] uppercase tracking-widest">{cat.label}</span>
                </div>

                <h3 className="text-3xl lg:text-4xl font-bold text-[#2C2C2C] mb-5 leading-tight">
                  {cat.title}
                </h3>
                <p className="text-gray-600 font-light leading-relaxed text-base mb-8">
                  {cat.description}
                </p>

                {/* Feature List */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                  {cat.features.map((feat, fi) => (
                    <li key={fi} className="flex items-center gap-2 text-sm text-[#2C2C2C] font-medium">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-checkbox-circle-fill text-[#1A4D4D] text-lg"></i>
                      </div>
                      {feat}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => scrollToSection('contatti')}
                  className="self-start flex items-center gap-3 bg-[#2C2C2C] text-white px-8 py-4 rounded-full font-medium hover:bg-[#1A4D4D] transition-colors cursor-pointer whitespace-nowrap group"
                >
                  <span className="text-sm uppercase tracking-wide">Richiedi Informazioni</span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-20 rounded-3xl bg-[#1A4D4D] p-12 lg:p-16 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-[#FF6B35] text-sm uppercase tracking-widest font-semibold mb-3">PERCHÉ SCEGLIERE LIOS</p>
            <h3 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
              Un unico interlocutore<br />per tutta la tua tecnologia
            </h3>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {[
              { value: 'TOP', label: 'Brand selezionati' },
              { value: 'CONFIG', label: 'Su misura per te' },
              { value: 'POST', label: 'Assistenza inclusa' },
              { value: 'FAST', label: 'Consegna rapida' },
            ].map((stat, si) => (
              <div key={si}>
                <div className="text-2xl font-bold text-[#FF6B35] mb-1">{stat.value}</div>
                <p className="text-white/70 text-sm font-light">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
